// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .Home-root-_ZJme {
 	padding-left: 0px;
 	padding-right: 0px;
 	overflow: hidden;
 }

 .Home-container-D2D0w {
 	margin: 0 auto;
 	max-width: 1274px;
 }

 .Home-pageContainer-uMq2F {
 	padding-top: 48px;
 }

 .Home-containerTitle-g3oEd {
 	color: var(--common-text-color);
 	margin: 0 0 35px;
 	font-weight: bold;
 	font-size: 36px;
 	text-align: center;
 }

 .Home-recommandBg-SSLru {
 	background-color: #F5FAFB;
 	padding: 60px 0;
 }

 .Home-topBottomCss-OMr3V {
 	padding: 60px 0 0;
 }

 .Home-sectionWidth-nbq8e {
 	max-width: 770px;
 	margin: 0 auto;
 }

 .Home-displayGrid-isUcU {
 	display: grid;
 	grid-template-columns: 24% 24% 24% 24%;
 	grid-gap: 25px;
 	margin: 0px 6px;
 }

 .Home-displayGridTwo-TN5Ez {
 	display: grid;
 	grid-template-columns: 192px 192px 192px 192px 192px 192px;
 	grid-gap: 25px;
 }

 @media screen and (max-width: 1170px) {
 	.Home-containerTitle-g3oEd {
 		text-align: center;
 	}
 }

 @media screen and (max-width: 1200px) {
 	.Home-container-D2D0w {
 		padding: 0 24px;
 	}

 	.Home-sectionWidth-nbq8e {
 		padding-left: 24px;
 		padding-right: 24px;
 	}

 }

 @media (max-width:1200px) and (min-width:992px) {
 	.Home-displayGrid-isUcU {
 		grid-template-columns: auto auto auto;
 		grid-gap: inherit;
 		-webkit-box-pack: center;
 		    -ms-flex-pack: center;
 		        justify-content: center;
 	}
 }

 @media (max-width:991px) and (min-width:768px) {
 	.Home-displayGrid-isUcU {
 		grid-template-columns: 223px 223px 223px;
 		grid-gap: 25px;
 		margin: 0;
 	}
 }

 @media (max-width:767px) {
 	.Home-displayGrid-isUcU {
 		grid-template-columns: 100%;
 		-webkit-box-pack: center;
 		    -ms-flex-pack: center;
 		        justify-content: center;
 		margin: 0;
 	}

 	.Home-displayGridTwo-TN5Ez {
 		grid-template-columns: 100%;
 	}

 	.Home-displayGridTwo-TN5Ez div:nth-child(2),
 	.Home-displayGridTwo-TN5Ez div:nth-child(3),
 	.Home-displayGridTwo-TN5Ez div:nth-child(4),
 	.Home-displayGridTwo-TN5Ez div:nth-child(5),
 	.Home-displayGridTwo-TN5Ez div:nth-child(6) {
 		display: none;
 	}
 }`, "",{"version":3,"sources":["webpack://./src/routes/home/Home.css"],"names":[],"mappings":"CAAC;EACC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;CACjB;;CAEA;EACC,cAAc;EACd,iBAAiB;CAClB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,yBAAyB;EACzB,eAAe;CAChB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;EAChB,cAAc;CACf;;CAEA;EACC,aAAa;EACb,sCAAsC;EACtC,cAAc;EACd,eAAe;CAChB;;CAEA;EACC,aAAa;EACb,0DAA0D;EAC1D,cAAc;CACf;;CAEA;EACC;GACC,kBAAkB;EACnB;CACD;;CAEA;EACC;GACC,eAAe;EAChB;;EAEA;GACC,kBAAkB;GAClB,mBAAmB;EACpB;;CAED;;CAEA;EACC;GACC,qCAAqC;GACrC,iBAAiB;GACjB,wBAAuB;OAAvB,qBAAuB;WAAvB,uBAAuB;EACxB;CACD;;CAEA;EACC;GACC,wCAAwC;GACxC,cAAc;GACd,SAAS;EACV;CACD;;CAEA;EACC;GACC,2BAA2B;GAC3B,wBAAuB;OAAvB,qBAAuB;WAAvB,uBAAuB;GACvB,SAAS;EACV;;EAEA;GACC,2BAA2B;EAC5B;;EAEA;;;;;GAKC,aAAa;EACd;CACD","sourcesContent":[" .root {\n \tpadding-left: 0px;\n \tpadding-right: 0px;\n \toverflow: hidden;\n }\n\n .container {\n \tmargin: 0 auto;\n \tmax-width: 1274px;\n }\n\n .pageContainer {\n \tpadding-top: 48px;\n }\n\n .containerTitle {\n \tcolor: var(--common-text-color);\n \tmargin: 0 0 35px;\n \tfont-weight: bold;\n \tfont-size: 36px;\n \ttext-align: center;\n }\n\n .recommandBg {\n \tbackground-color: #F5FAFB;\n \tpadding: 60px 0;\n }\n\n .topBottomCss {\n \tpadding: 60px 0 0;\n }\n\n .sectionWidth {\n \tmax-width: 770px;\n \tmargin: 0 auto;\n }\n\n .displayGrid {\n \tdisplay: grid;\n \tgrid-template-columns: 24% 24% 24% 24%;\n \tgrid-gap: 25px;\n \tmargin: 0px 6px;\n }\n\n .displayGridTwo {\n \tdisplay: grid;\n \tgrid-template-columns: 192px 192px 192px 192px 192px 192px;\n \tgrid-gap: 25px;\n }\n\n @media screen and (max-width: 1170px) {\n \t.containerTitle {\n \t\ttext-align: center;\n \t}\n }\n\n @media screen and (max-width: 1200px) {\n \t.container {\n \t\tpadding: 0 24px;\n \t}\n\n \t.sectionWidth {\n \t\tpadding-left: 24px;\n \t\tpadding-right: 24px;\n \t}\n\n }\n\n @media (max-width:1200px) and (min-width:992px) {\n \t.displayGrid {\n \t\tgrid-template-columns: auto auto auto;\n \t\tgrid-gap: inherit;\n \t\tjustify-content: center;\n \t}\n }\n\n @media (max-width:991px) and (min-width:768px) {\n \t.displayGrid {\n \t\tgrid-template-columns: 223px 223px 223px;\n \t\tgrid-gap: 25px;\n \t\tmargin: 0;\n \t}\n }\n\n @media (max-width:767px) {\n \t.displayGrid {\n \t\tgrid-template-columns: 100%;\n \t\tjustify-content: center;\n \t\tmargin: 0;\n \t}\n\n \t.displayGridTwo {\n \t\tgrid-template-columns: 100%;\n \t}\n\n \t.displayGridTwo div:nth-child(2),\n \t.displayGridTwo div:nth-child(3),\n \t.displayGridTwo div:nth-child(4),\n \t.displayGridTwo div:nth-child(5),\n \t.displayGridTwo div:nth-child(6) {\n \t\tdisplay: none;\n \t}\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Home-root-_ZJme`,
	"container": `Home-container-D2D0w`,
	"pageContainer": `Home-pageContainer-uMq2F`,
	"containerTitle": `Home-containerTitle-g3oEd`,
	"recommandBg": `Home-recommandBg-SSLru`,
	"topBottomCss": `Home-topBottomCss-OMr3V`,
	"sectionWidth": `Home-sectionWidth-nbq8e`,
	"displayGrid": `Home-displayGrid-isUcU`,
	"displayGridTwo": `Home-displayGridTwo-TN5Ez`
};
module.exports = ___CSS_LOADER_EXPORT___;
